export default __webpack_public_path__ + "6341370b031361cea5a04fddb2d9ff43.png";